import { createAsyncThunk } from "@reduxjs/toolkit";
import { postLoginService } from "../../Services";
import { alert } from "../../utils/commonFunctions/alert";

// Fetch all influencers
export const fetchInfluencers = createAsyncThunk(
    "influencer/fetchInfluencers",
    async (_, { rejectWithValue }) => {
        try {
            const url = `/api/influencers`;
            const response = await postLoginService.get(url);
            // console.log("FETCH INFLUENCERS RESPONSE---->", response);

            if (response?.success) {
                return response;
            } else {
                const errorMessage = response?.message || "Failed to fetch influencers";
                alert.error(errorMessage);
                return rejectWithValue(errorMessage);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to fetch influencers";
            alert.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

// Get influencer profile
export const getInfluencerProfile = createAsyncThunk(
    "influencer/getProfile",
    async (_, { rejectWithValue }) => {
        try {
            const url = `/api/influencers/profile/me`;
            const response = await postLoginService.get(url);
            // console.log("GET INFLUENCER PROFILE RESPONSE---->", response);

            if (response?.success) {
                return response;
            } else {
                const errorMessage = response?.message;
                alert.error(errorMessage);
                return rejectWithValue(errorMessage);
            }
        } catch (error) {
            const statusCode = error?.response?.status || error?.status;
            const isAuthTransitionError = statusCode === 401 || statusCode === 403;
            const errorMessage = error?.response?.data?.message;
            if (!isAuthTransitionError) {
                alert.error(errorMessage);
            }
            return rejectWithValue(errorMessage);
        }
    }
);

// Update influencer profile
export const updateInfluencerProfile = createAsyncThunk(
    "influencer/updateProfile",
    async (profileData, { rejectWithValue }) => {
        try {
            const url = `/api/influencers/profile/me`;
            const response = await postLoginService.put(url, profileData);
            // console.log("UPDATE INFLUENCER PROFILE RESPONSE---->", response);

            if (response?.success) {
                // alert.success(response?.message || "Profile updated successfully");
                return response;
            } else {
                const errorMessage = response?.message || "Failed to update profile";
                alert.error(errorMessage);
                return rejectWithValue(errorMessage);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to update profile";
            alert.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

// Upload profile image
export const uploadProfileImage = createAsyncThunk(
    "influencer/uploadProfileImage",
    async (imageFile, { rejectWithValue }) => {
        try {
            const url = `/api/influencers/profile/image`;
            const formData = new FormData();
            formData.append('image', imageFile);

            const response = await postLoginService.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            // console.log("UPLOAD PROFILE IMAGE RESPONSE---->", response);

            if (response?.success) {
                // alert.success(response?.message || "Profile image uploaded successfully");
                return response;
            } else {
                const errorMessage = response?.message || "Failed to upload profile image";
                alert.error(errorMessage);
                return rejectWithValue(errorMessage);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to upload profile image";
            alert.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

// Upload intro reel
export const uploadIntroReel = createAsyncThunk(
    "influencer/uploadIntroReel",
    async (videoFile, { rejectWithValue }) => {
        try {
            const url = `/api/influencers/profile/intro-reel`;
            const formData = new FormData();
            formData.append('video', videoFile);

            const response = await postLoginService.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            // console.log("UPLOAD INTRO REEL RESPONSE---->", response);

            if (response?.success) {
                // alert.success(response?.message);
                return response;
            } else {
                const errorMessage = response?.message || "Failed to upload intro reel";
                alert.error(errorMessage);
                return rejectWithValue(errorMessage);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to upload intro reel";
            alert.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

// Upload reel thumbnail
export const uploadReelThumbnail = createAsyncThunk(
    "influencer/uploadReelThumbnail",
    async (imageFile, { rejectWithValue }) => {
        try {
            const url = `/api/influencers/profile/reel-thumbnail`;
            const formData = new FormData();
            formData.append('image', imageFile);

            const response = await postLoginService.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            // console.log("UPLOAD REEL THUMBNAIL RESPONSE---->", response);

            if (response?.success) {
                // alert.success(response?.message || "Reel thumbnail uploaded successfully");
                return response;
            } else {
                const errorMessage = response?.message || "Failed to upload reel thumbnail";
                alert.error(errorMessage);
                return rejectWithValue(errorMessage);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to upload reel thumbnail";
            alert.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

// Delete intro reel
export const deleteIntroReel = createAsyncThunk(
    "influencer/deleteIntroReel",
    async (_, { rejectWithValue }) => {
        try {
            const url = `/api/influencers/profile/intro-reel`;
            const response = await postLoginService.delete(url);
            // console.log("DELETE INTRO REEL RESPONSE---->", response);

            if (response?.success) {
                // alert.success(response?.message || "Intro reel deleted successfully");
                return response;
            } else {
                const errorMessage = response?.message || "Failed to delete intro reel";
                alert.error(errorMessage);
                return rejectWithValue(errorMessage);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to delete intro reel";
            alert.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

// Delete reel thumbnail
export const deleteReelThumbnail = createAsyncThunk(
    "influencer/deleteReelThumbnail",
    async (_, { rejectWithValue }) => {
        try {
            const url = `/api/influencers/profile/reel-thumbnail`;
            const response = await postLoginService.delete(url);
            // console.log("DELETE REEL THUMBNAIL RESPONSE---->", response);

            if (response?.success) {
                // alert.success(response?.message || "Reel thumbnail deleted successfully");
                return response;
            } else {
                const errorMessage = response?.message || "Failed to delete reel thumbnail";
                alert.error(errorMessage);
                return rejectWithValue(errorMessage);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to delete reel thumbnail";
            alert.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);

// Change influencer password
export const changeInfluencerPassword = createAsyncThunk(
    "influencer/changePassword",
    async (passwordData, { rejectWithValue }) => {
        try {
            const url = `/api/auth/change-password`;
            const response = await postLoginService.post(url, passwordData);
            // console.log("CHANGE INFLUENCER PASSWORD RESPONSE---->", response);

            if (response?.success) {
                alert.success(response?.message || "Password changed successfully");
                return response;
            } else {
                const errorMessage = response?.message || "Failed to change password";
                alert.error(errorMessage);
                return rejectWithValue(errorMessage);
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error?.message || "Failed to change password";
            alert.error(errorMessage);
            return rejectWithValue(errorMessage);
        }
    }
);
